/**
 * Every id stored in the document is minted here (#293, ADR 0012:194-200).
 *
 * Minting is a substrate concern because `AppDocument` is multi-writer by construction (ADR 0002,
 * ADR 0003): whether two devices can mint the same id is a property of the document, not of the
 * surface that happened to call. Four schemes minted document ids before this module existed, and
 * the one with no randomness at all (`task-checklist.tsx:291`, #182) was written and stayed
 * unnoticed precisely because no module owned the question.
 *
 * Nothing migrates. Existing ids stay valid whatever minted them, and the tree already hard-depends
 * on `crypto.randomUUID()` at 13 sites with no polyfill, so this is additive.
 */

/**
 * A new id for something stored in the document — an entry, a link, a topic, a project.
 *
 * Not for ids that never enter the document: the peer id (`repo.ts`), the embedding job id
 * (`EmbeddingProvider.tsx`) and the pending-capture id in localStorage (`pending-entries.ts`) are
 * not document ids and do not come from here.
 */
export function newId(): string {
  return crypto.randomUUID()
}
